/**
 * Erreur de règle de jeu ou d'usage : son message est rédigé en français et
 * destiné à être affiché tel quel au joueur.
 */
export class RuleError extends Error {
  override readonly name = 'RuleError';

  constructor(message: string) {
    super(message);
  }
}

export function isRuleError(error: unknown): error is RuleError {
  return error instanceof RuleError;
}
